import PropTypes from 'prop-types'

// Column headers component for flow diagram
const FlowHeader = ({ layout }) => {
  const { xTheme, xOutcome, xImpact, pillW } = layout

  return (
    <g fontSize={17} fontWeight={400} fontStyle="normal" fill="#111">
      <text x={xTheme + pillW / 2} y={50} textAnchor="middle">
        Vision 2030
      </text>
      <text x={xOutcome + pillW / 2} y={50} textAnchor="middle">
        RCU Criteria
      </text>
      <text x={xImpact + pillW / 2} y={50} textAnchor="middle">
        Impact
      </text>
    </g>
  )
}

FlowHeader.propTypes = {
  layout: PropTypes.shape({
    xTheme: PropTypes.number.isRequired,
    xOutcome: PropTypes.number.isRequired,
    xImpact: PropTypes.number.isRequired,
    pillW: PropTypes.number.isRequired
  }).isRequired
}

export default FlowHeader
